module.exports = __webpack_public_path__ + "static/img/kjhf1.3d60a95.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjhf1.jpeg
// module id = 1232
// module chunks = 0